// userConfirmationSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

// AsyncThunk to confirm a user's email
export const confirmUser = createAsyncThunk(
  'userConfirmation/confirmUser',
  async (token, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(`/api/users/confirm/${token}`, {}, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

// Fetch email associated with registration token
export const getRegisterEmail = createAsyncThunk(
  'userConfirmation/getRegisterEmail',
  async (token, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data } = await axios.post(`/api/users/registerconfirm/${token}`, {}, config)
      // backend returns { message: email }
      return { email: data.message }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

// Resend confirmation email
export const resendConfirmationEmail = createAsyncThunk(
  'userConfirmation/resendConfirmationEmail',
  async ({ email, grecaptcha }, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data } = await axios.post('/api/users/resendconfirmation', { email, grecaptcha }, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

const userConfirmationSlice = createSlice({
  name: 'userConfirmation',
  initialState: {
    success: false,
    loading: false,
    error: null,
    email: null,
    resendLoading: false,
    resendSuccess: false,
    resendError: null,
  },
  reducers: {
    resetConfirmationState: (state) => {
      state.success = false
      state.loading = false
      state.error = null
      state.email = null
      state.resendLoading = false
      state.resendSuccess = false
      state.resendError = null
    },
    resetResendState: (state) => {
      state.resendLoading = false
      state.resendSuccess = false
      state.resendError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // confirm
      .addCase(confirmUser.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(confirmUser.fulfilled, (state) => {
        state.loading = false
        state.success = true
      })
      .addCase(confirmUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // get email
      .addCase(getRegisterEmail.pending, (state) => {
        state.loading = true
        state.error = null
        state.email = null
      })
      .addCase(getRegisterEmail.fulfilled, (state, action) => {
        state.loading = false
        state.email = action.payload.email
      })
      .addCase(getRegisterEmail.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // resend confirmation
      .addCase(resendConfirmationEmail.pending, (state) => {
        state.resendLoading = true
        state.resendError = null
        state.resendSuccess = false
      })
      .addCase(resendConfirmationEmail.fulfilled, (state) => {
        state.resendLoading = false
        state.resendSuccess = true
      })
      .addCase(resendConfirmationEmail.rejected, (state, action) => {
        state.resendLoading = false
        state.resendError = action.payload
      })
  },
})

export const { resetConfirmationState, resetResendState } = userConfirmationSlice.actions
export default userConfirmationSlice.reducer
